import { Button } from '@design/components/button/Button';
import { Drawer } from '@design/components/drawer/Drawer';
import { DrawerContentWrapper } from '@terminal/components/drawer-content-wrapper/DrawerContentWrapper';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { CalendarEventDrawerHeader } from './calendar-event-drawer-header/CalendarEventDrawerHeader';
import styles from './CalendarEventDrawer.module.scss';

type CalendarEventDrawerHeaderContent = {
  title: string;
  subtitle: string;
  dateString: string;
  titleLogo?: ReactNode;
  reported?: boolean;
  companyEvent?: boolean;
};

export interface CalendarEventDrawerProps {
  closeDrawer: () => void;
  isOpen: boolean;
  drawerContent?: ReactNode;
  headerContent?: CalendarEventDrawerHeaderContent;
  onFullScreenClick?: () => void;
}

export const CalendarEventDrawer = ({
  isOpen,
  drawerContent,
  headerContent,
  closeDrawer,
  onFullScreenClick,
}: CalendarEventDrawerProps) => {
  const { t } = useTranslation(['calendar']);
  return (
    <Drawer
      data-testid="calendar-events-drawer"
      data-drawer-state={
        isOpen ? 'calendar-event-open' : 'calendar-event-closed'
      }
      isOpen={isOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        onFullScreenClick && (
          <Button
            variant="empty"
            iconName="Expand"
            onClick={onFullScreenClick}
            label={t('calendar:viewMore')}
            size="xsmall"
          />
        )
      }
    >
      <DrawerContentWrapper>
        <div className={styles.contentWrapper}>
          {headerContent && (
            <CalendarEventDrawerHeader
              title={headerContent.title}
              subtitle={headerContent.subtitle}
              logoNode={headerContent.titleLogo}
              dateString={headerContent.dateString}
              reported={headerContent.reported}
              companyEvent={headerContent.companyEvent}
            />
          )}
          {drawerContent}
        </div>
      </DrawerContentWrapper>
    </Drawer>
  );
};
